import { Menu } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { useCompany } from "#modules/company/view/useCompany";
import { useExportQuote } from "#modules/quoteRequests/view/useExportQuote";
import { Icon } from "#shared/icons/Icon";
import { AnalyticsEvent, useAnalytics } from "#shared/useAnalytics";

export const QuoteRequestActionsMenuItemExport = ({
  quoteRequestId,
}: {
  quoteRequestId: string;
}) => {
  const { company } = useCompany();
  const { t } = useTranslation();
  const { exportQuote, isPending: isExportLoading } = useExportQuote();
  const analytics = useAnalytics();

  const canExportToERP = company?.companySettings.areQuotesERPExportable || false;

  const handleExportQuote = () => {
    analytics.capture(AnalyticsEvent.QuoteErpExported, { quote_request_id: quoteRequestId });
    exportQuote({
      quoteId: quoteRequestId,
    });
  };

  if (!canExportToERP) {
    return null;
  }

  return (
    <Menu.Item
      leftSection={<Icon name="file" size={14} />}
      onClick={handleExportQuote}
      disabled={isExportLoading}
    >
      {t("quoteRequestLine.actions.exportQuote.menuItem")}
    </Menu.Item>
  );
};
